'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'arrow-up';
var width = 384;
var height = 512;
var aliases = [8593];
var unicode = 'f062';
var svgPathData = 'M209.5 7c-9.4-9.4-24.6-9.4-33.9 0L7.5 175c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l127-127 0 406.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-406.1 127 127c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209.5 7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;